import { CHINA_MAP_LABEL_FONT_SIZE } from "@-/dev.improve.haniverse.data.china-map";
import {
  CHINA_MAP_CITY_LABEL_MIN_FONT_SIZE,
  CHINA_MAP_PROVINCE_LABEL_MIN_FONT_SIZE,
} from "#china-map-places";

/*
 * Names are laid out (`getChinaMapLabels`) only once the camera comes to rest, while a pinch or a
 * flight moves it every frame. In between, each name keeps its layout and these worklets size and
 * fade it for the live zoom, so the names follow a zoom frame by frame. At the zoom a name was laid
 * out at, they give the size and opacity it was laid out with, so nothing jumps when it settles.
 *
 * Each takes the layout's `em` (the largest size, in map units, at which the layout holds the
 * name) rather than the label, so a worklet captures only numbers, never a place's outline.
 */

/**
 * A name's font size, in screen px, with the camera at `scale`: the full size while its layout has
 * room for it, smaller as that room shrinks, but never smaller than a province's name is drawn.
 */
export function getChinaMapLabelZoomFontSize(em: number, scale: number): number {
  "worklet";
  return Math.min(
    CHINA_MAP_LABEL_FONT_SIZE,
    Math.max(CHINA_MAP_PROVINCE_LABEL_MIN_FONT_SIZE, em * scale),
  );
}

/** The scale, in map units per px, of a name drawn at the full font size, with the camera at `scale`. */
export function getChinaMapLabelZoomPictureScale(em: number, scale: number): number {
  "worklet";
  return getChinaMapLabelZoomFontSize(em, scale) / CHINA_MAP_LABEL_FONT_SIZE / scale;
}

/**
 * A city name's opacity with the camera at `scale`. A city is named only where its layout holds
 * the name at `CHINA_MAP_CITY_LABEL_MIN_FONT_SIZE`, so as zooming out shrinks it below that size,
 * the name fades out instead of crowding its neighbours until the names are laid out again.
 */
export function getChinaMapCityLabelZoomOpacity(em: number, scale: number): number {
  "worklet";
  return Math.min(
    1,
    Math.max(
      0,
      (em * scale - CHINA_MAP_PROVINCE_LABEL_MIN_FONT_SIZE) /
        (CHINA_MAP_CITY_LABEL_MIN_FONT_SIZE - CHINA_MAP_PROVINCE_LABEL_MIN_FONT_SIZE),
    ),
  );
}
